<template>
  <b-card class="product-card mb-0 position-relative">
    <div
      v-if="showRemove"
      class="position-absolute"
      style="top: 0; right: 0"
    >
      <e-button-icon
        icon="XIcon"
        variant="danger"
        style="padding: 12px"
        @click="onRemoveItem"
      />
    </div>

    <b-img
      v-if="!!productPriceInfo.flagImg"
      :src="productPriceInfo.flagImg"
      width="150"
      height="150"
      class="position-absolute"
      style="top: -15px; left: 0px; object-fit: contain"
    />

    <div class="card-container">
      <div class="d-flex justify-content-center">
        <b-img
          :src="product.imageSquare || logoImg"
          width="150"
          height="150"
          alt="Fluid image"
          class="rounded"
          style="object-fit: contain"
        />
      </div>

      <div>
        <p class="mb-0 h4 font-weight-bold">
          {{ product.name }}
        </p>
      </div>

      <div class="mt-auto">
        <div class="d-flex gap-2">
          <p class="mb-0 product-price">
            {{ productPriceInfo.price | currency('', 2) }}
          </p>
          <p
            v-if="productPriceInfo.hasOldPrice"
            class="product-price-canceled h5 small"
          >
            {{ productPriceInfo.oldPrice | currency('', 2) }}
          </p>
        </div>
      </div>

      <div>
        <item-quantity-input
          :id="id"
          :product="product"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import EButtonIcon from '@/views/components/EButtonIcon.vue'
import { BImg, BCard } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import logoImg from '@/assets/images/logo/echope_small.png'
import promotionImg from '@/assets/images/on_promotion.png'
import tieredPriceImg from '@/assets/images/leve-mais-pague-menos.png'
import { payBoxSale, payBoxUtils } from '@/mixins'
import ItemQuantityInput from '../input/ItemQuantityInput.vue'

export default {
  components: {
    BCard,
    BImg,
    EButtonIcon,
    ItemQuantityInput,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      default: 'productCard',
    },

    readOnly: {
      type: Boolean,
      default: false,
    },
    showRemove: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      logoImg,
      promotionImg,
      tieredPriceImg,
    }
  },

  computed: {
    ...mapGetters('pages/pdv/payBox', ['getItems', 'getDictSaleItems']),

    productPriceInfo() {
      const hasTieredPrices = this.product?.hasTieredPrices
      const { hasOldPrice, price, oldPrice, ruleType } = payBoxUtils.buildSearchedProductPrice(
        this.product
      )

      const priceData = {
        hasOldPrice,
        price,
        oldPrice,
        hasTieredPrices: false,
        flagImg: '',
        flagDescription: '',
      }

      if (ruleType === payBoxUtils.priceRuleTypes.PROMOTION) {
        priceData.flagImg = this.promotionImg
        priceData.flagDescription = 'Bandeira de que produto está em promoção.'
      } else if (ruleType === payBoxUtils.priceRuleTypes.TIERED_PRICE) {
        priceData.flagImg = this.tieredPriceImg
        priceData.flagDescription = 'Bandeira de compre mais e pague menos.'
        priceData.hasTieredPrices = true
      }

      const saleProductKey = payBoxSale.methods.getSaleProductKey({
        kitId: (this.product.kit && this.product.id) || 0,
        promotionId: this.product.promotionId,
        skuId: !this.product.kit && this.product.id,
      })
      const saleItem = this.getDictSaleItems[saleProductKey]
      if (saleItem?.priceRuleSelected) {
        const { priceRuleSelected } = saleItem
        priceData.hasOldPrice = priceRuleSelected?.priceInfo.hasOldPrice
        priceData.oldPrice = priceRuleSelected?.priceInfo.oldPrice
        priceData.price = priceRuleSelected?.priceInfo.price
      }

      return {
        hasTieredPrices,
        ...priceData,
      }
    },
  },

  methods: {
    ...mapActions('pages/pdv/atm', { stRemoveItemFromAtm: 'removeItemFromAtm' }),

    getItemCart() {
      const itemFound = this.getItems?.find(
        payBoxSale.methods.productInSaleItemFilter(this.product)
      )
      return itemFound
    },

    onRemoveItem() {
      const item = this.getItemCart()
      this.removeItem(item)
    },

    async removeItem(item) {
      await this.stRemoveItemFromAtm(item)
    },
  },
}
</script>

<style lang="scss" scoped>
.product-card {
  position: inherit;
  height: 350px;

  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  padding-bottom: 0;
  border-radius: 1em;
}

.product-card:nth-last-child(1) {
  margin-left: 0px;
  margin-right: auto;
}

.card-container {
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
</style>
